document.addEventListener('DOMContentLoaded', (event) => {
    // Initial values are server-rendered by Liquid into the overview divs.
    // We only need to listen for subsequent variant changes from the JS selector.
    window.addEventListener('variantChange.ecomify.product', (event) => {
        const selectedVariant = event.detail;
        updateVariantDetails(selectedVariant);
    });
});

function updateVariantDetails(variant) {
    updateBullyStickThicknessDetails(variant);
    updateDogSizeDetails(variant);
    updateLifeStageDetails(variant);
    updateBullyStickWeightDetails(variant);
    updateChewerTypeDetails(variant);
}

function updateBullyStickThicknessDetails(variant) {
    const detailsDiv = document.querySelector('#bullyStickThickness-details');
    if (!detailsDiv) return;

    const variantMetafields = JSON.parse(document.getElementById('variant_metafield_data').textContent);
    const metafields = variantMetafields[variant.id];
    const value = metafields ? metafields["custom.thickness"] : null;

    //console.log('Bully Stick Thickness:', value);
    detailsDiv.innerHTML = parseMetafield(value);
}

function updateDogSizeDetails(variant) {
    const detailsDiv = document.querySelector('#dogSize-details');
    const specsDiv = document.querySelector('#dogSize-specs');
    if (!detailsDiv && !specsDiv) return;

    const variantMetafields = JSON.parse(document.getElementById('variant_metafield_data').textContent);
    const metafields = variantMetafields[variant.id];
    const value = metafields ? metafields["custom.dog_size"] : null;
    const parsedValue = parseMetafield(value);

    if (detailsDiv) detailsDiv.innerHTML = parsedValue;
    if (specsDiv) specsDiv.innerHTML = parsedValue;
}

function updateLifeStageDetails(variant) {
    const detailsDiv = document.querySelector('#lifeStage-details');
    if (!detailsDiv) return;

    const variantMetafields = JSON.parse(document.getElementById('variant_metafield_data').textContent);
    const metafields = variantMetafields[variant.id];
    const value = metafields ? metafields["custom.life_stage"] : null;
    detailsDiv.innerHTML = parseMetafield(value);
}

function updateBullyStickWeightDetails(variant) {
    const detailsDiv = document.querySelector('#bullyStickWeight-details');
    const specsDiv = document.querySelector('#bullyStickWeight-specs');
    if (!detailsDiv && !specsDiv) return;

    const variantMetafields = JSON.parse(document.getElementById('variant_metafield_data').textContent);
    const metafields = variantMetafields[variant.id];
    const value = metafields ? metafields["custom.weight_range"] : null;
    const parsedValue = parseMetafield(value);

    if (detailsDiv) detailsDiv.innerHTML = parsedValue;
    if (specsDiv) specsDiv.innerHTML = parsedValue;
}

function updateChewerTypeDetails(variant) {
    const detailsDiv = document.querySelector('#chewerType-details');
    const specsDiv = document.querySelector('#chewerType-specs');
    if (!detailsDiv && !specsDiv) return;

    const variantMetafields = JSON.parse(document.getElementById('variant_metafield_data').textContent);
    const metafields = variantMetafields[variant.id];
    const value = metafields ? metafields["custom.chewer_type"] : null;
    const parsedValue = parseMetafield(value);

    if (detailsDiv) detailsDiv.innerHTML = parsedValue;
    if (specsDiv) specsDiv.innerHTML = parsedValue;
}


function parseMetafield(value) {
    if (typeof value === 'string') {
        return value.replace(/^\["|"\]$/g, '').replace(/","/g, ', ');
    }
    if (Array.isArray(value)) {
        return value.join(', ');
    }
    return value || 'N/A';
}

//READ MORE
document.addEventListener('DOMContentLoaded', function () {
  var readMoreToggles = document.querySelectorAll('.read-more-toggle')

  readMoreToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var target = document.querySelector(toggle.getAttribute('data-target'))
      var fullText = toggle.getAttribute('data-full-text')

      // Truncate by words
      var words = fullText.split(' ') // Split text into an array of words
      var wordLimit = 200 // Set the word limit to 200 (matching the Liquid file)
      var truncatedText = words.slice(0, wordLimit).join(' ') + '...' // Join the limited words back with spaces

      if (target) {
        if (target.innerHTML.includes('...')) {
          // Show full description
          target.innerHTML = fullText
          toggle.textContent = 'Read Less'
        } else {
          // Collapse description back to truncated words
          target.innerHTML = truncatedText
          toggle.textContent = 'Read More'
        }
      }
    })
  })
})

//STICKY ATC
document.addEventListener('DOMContentLoaded', function() {
    const buyButtons = document.querySelector('.product-buy-buttons-inner');
    let lastScrollTop = 0;

    if (!buyButtons) {
        console.log('Element .product-buy-buttons-inner not found.');
        return;
    }

    function toggleBuyButtonsVisibility() {
        const isMobile = window.innerWidth <= 768; // Mobile breakpoint

        if (isMobile) {
            let currentScrollTop = window.pageYOffset;

            if (currentScrollTop > lastScrollTop) {
                // User is scrolling down
                buyButtons.style.display = 'flex';
            }

            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For mobile or negative scrolling
        }
    }

    window.addEventListener('scroll', toggleBuyButtonsVisibility);

    // Initially hide the element on mobile
    if (window.innerWidth <= 768) {
        buyButtons.style.display = 'none';
    }
});

//MOVE TESTIMONIALS UNDER GALLERY ON DESKTOP

(function () {
  const G = '.product-gallery';
  const T = '.product-block-testimonial';
  const MQ = '(min-width: 992px)'; // desktop breakpoint

  function place() {
    const gallery = document.querySelector(G);
    const t = document.querySelector(T);
    if (!gallery || !t) return false;

    if (window.matchMedia(MQ).matches) {
      // Only move on desktop, and only if not already placed
      if (t.previousElementSibling !== gallery) {
        gallery.after(t);
        t.classList.add('pdp-testimonial-under-gallery');
      }
    }
    return true;
  }

  function init(attempts = 8) {
    if (place() || attempts <= 0) return;
    setTimeout(() => init(attempts - 1), 200);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', () => init());
  document.addEventListener('shopify:section:reorder', () => init());
  window.addEventListener('resize', place);
})();

// Swap .btn-atc-text based on live variant state
document.addEventListener('variant:change', function (e) {
  var v = (e.detail && (e.detail.variant || e.detail.selectedVariant)) || null;
  var t = document.querySelector('.btn-atc-text');
  if (!t || !v) return;

  var isPreorder = (v.inventory_policy === 'continue' && v.inventory_quantity <= 0);
  t.textContent = isPreorder ? 'PREORDER' : 'Add To Cart';

  var btn = t.closest('button');
  if (btn) {
    btn.setAttribute('data-text-add-to-cart', t.textContent);
    btn.setAttribute('aria-label', isPreorder ? 'Preorder this item' : 'Add this item to cart');
  }
});

/**
 * Floating Progress Bubble TOC - Reusable JavaScript
 * BullyStick.com Custom JavaScript
 */

function initFloatingTOC(sections) {
    const bubble = document.querySelector('.floating-toc-bubble');
    const overlay = document.querySelector('.toc-overlay');
    const panel = document.querySelector('.toc-panel');
    const closeBtn = document.querySelector('.toc-close-btn');
    const tocLinks = document.querySelectorAll('.toc-panel-list a');
    const jumpNav = document.querySelector('.jump-nav');
    
    // Bubble elements
    const sectionNum = document.querySelector('.bubble-section-num');
    const dots = document.querySelector('.bubble-dots');
    const percentage = document.querySelector('.bubble-percentage');
    const progressRing = document.querySelector('.progress-ring-progress');
    const progressBar = document.querySelector('.toc-progress-bar');
    const progressText = document.querySelector('.toc-progress-text');
    
    // Progress ring calculations
    const radius = 35;
    const circumference = 2 * Math.PI * radius; // 219.91
    
    const totalSections = sections.length;
    let currentSectionIndex = 0;
    
    function handleBubbleVisibility() {
        if (!bubble || !jumpNav) return;
        const jumpNavBottom = jumpNav.offsetTop + jumpNav.offsetHeight;
        const scrollPosition = window.scrollY;
        if (scrollPosition > jumpNavBottom + 100) {
            bubble.classList.add('visible');
        } else {
            bubble.classList.remove('visible');
        }
    }
    
    function updateProgress() {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY;
        const scrollPercent = Math.min((scrollTop / (documentHeight - windowHeight)) * 100, 100);
        
        let newSectionIndex = 0;
        sections.forEach((section, index) => {
            const element = document.getElementById(section.id);
            if (element) {
                const sectionTop = element.offsetTop - 150;
                if (scrollTop >= sectionTop) {
                    newSectionIndex = index;
                }
            }
        });
        
        currentSectionIndex = newSectionIndex;
        updateBubbleContent(currentSectionIndex + 1, scrollPercent);
        updateTOCStates(currentSectionIndex);
        
        if (progressBar) progressBar.style.width = scrollPercent + '%';
        if (progressText) progressText.textContent = Math.round(scrollPercent) + '% Complete';
    }
    
    function updateBubbleContent(sectionNumber, percent) {
        if (sectionNum) sectionNum.textContent = sectionNumber + '/' + totalSections;
        
        if (dots) {
            const filledDots = Math.ceil((sectionNumber / totalSections) * 5);
            let dotsText = '';
            for (let i = 0; i < 5; i++) {
                dotsText += i < filledDots ? '●' : '○';
            }
            dots.textContent = dotsText;
        }
        
        if (percentage) percentage.textContent = Math.round(percent) + '%';
        
        if (progressRing) {
            const offset = circumference - (percent / 100) * circumference;
            progressRing.style.strokeDashoffset = offset;
        }
    }
    
    function updateTOCStates(activeIndex) {
        tocLinks.forEach((link, index) => {
            const icon = link.querySelector('.toc-section-icon');
            link.classList.remove('completed', 'active');
            icon.classList.remove('completed', 'active', 'upcoming');
            
            if (index < activeIndex) {
                link.classList.add('completed');
                icon.classList.add('completed');
                icon.textContent = '✓';
            } else if (index === activeIndex) {
                link.classList.add('active');
                icon.classList.add('active');
                icon.textContent = '→';
            } else {
                icon.classList.add('upcoming');
                icon.textContent = '○';
            }
        });
    }
    
    function openOverlay() {
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
    
    function closeOverlay() {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
    }
    
    if (bubble) bubble.addEventListener('click', openOverlay);
    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
    
    if (overlay) {
        overlay.addEventListener('click', function(e) {
            if (e.target === overlay) closeOverlay();
        });
    }
    
    tocLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
                window.scrollTo({ top: targetSection.offsetTop - 100, behavior: 'smooth' });
                setTimeout(closeOverlay, 300);
            }
        });
    });
    
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.classList.contains('active')) closeOverlay();
    });
    
    let scrollTimeout;
    window.addEventListener('scroll', function() {
        handleBubbleVisibility();
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateProgress, 10);
    });
    
    handleBubbleVisibility();
    updateProgress();
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = { initFloatingTOC };
}


//SIZE GUIDE POP
(function () {
  function initSizeGuide() {
    const modals = document.querySelectorAll('.size-guide-modal');
    if (!modals.length) return;

    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-size-guide-open]');
      if (openBtn) {
        e.preventDefault();
        const modalId = openBtn.getAttribute('aria-controls');
        const modal = modalId ? document.getElementById(modalId) : null;
        if (!modal) return;
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', 'open');
        return;
      }

      const closeBtn = e.target.closest('[data-size-guide-close]');
      if (closeBtn) {
        const modal = closeBtn.closest('dialog');
        if (!modal) return;
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }
    });

    modals.forEach((modal) => {
      modal.addEventListener('cancel', (e) => {
        e.preventDefault();
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      });

      modal.addEventListener('click', (e) => {
        const inner = modal.querySelector('.size-guide-modal__inner');
        if (!inner) return;
        if (!inner.contains(e.target)) {
          if (typeof modal.close === 'function') modal.close();
          else modal.removeAttribute('open');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }
})();

// ─── Thickness chip helpers ───────────────────────────────────────────────────
// Shared by variant-selector.liquid (bully sticks) and
// product-block-variant-selector-combined.liquid (odor-free straight).
// Defined here so both product.js and product-combined.js have one source.

/*
  updateThicknessHelper(input)
  Reads data-helper text from the clicked Thickness chip and writes it
  into the <p id="thickness-helper-{productId}"> below the chip row.
*/
window.updateThicknessHelper = function (input) {
  var id = input.getAttribute('data-helper-target');
  var el = id ? document.getElementById(id) : null;
  if (!el) return;
  var text = input.getAttribute('data-helper');
  el.textContent = text ? '\u{1F4A1} ' + text : '';
};

/*
  fixQuantityForThickness(thicknessInput)
  When switching thickness, the currently-selected quantity pack may not
  exist for the new thickness (e.g. Monster only comes in 3/6 Pack).
  Detects the mismatch and auto-selects the first valid quantity,
  firing a change event so the variant updates correctly.
*/
window.fixQuantityForThickness = function (thicknessInput) {
  setTimeout(function () {
    var thicknessPos = null;
    var quantityPos  = null;

    var _product = (typeof product !== 'undefined' ? product : null) || window.__productJSON;
    if (!_product || !_product.options) return;

    _product.options.forEach(function (opt, i) {
      var lower = opt.toLowerCase();
      if (lower === 'thickness') thicknessPos = i;
      if (lower === 'quantity')  quantityPos  = i;
    });

    if (thicknessPos === null || quantityPos === null) return;

    var newThickness = thicknessInput.value;

    var quantityInputs = document.querySelectorAll('input[name="option-quantity"]');
    if (!quantityInputs.length) return;

    var currentQuantity = null;
    quantityInputs.forEach(function (inp) {
      if (inp.checked) currentQuantity = inp.value;
    });

    var validMatch = _product.variants.find(function (v) {
      return (
        v.options[thicknessPos] === newThickness &&
        v.options[quantityPos]  === currentQuantity
      );
    });

    if (validMatch) return;

    var firstValid = _product.variants.find(function (v) {
      return v.options[thicknessPos] === newThickness && v.available;
    });

    if (!firstValid) {
      firstValid = _product.variants.find(function (v) {
        return v.options[thicknessPos] === newThickness;
      });
    }

    if (!firstValid) return;

    var targetQty = firstValid.options[quantityPos];
    var targetInput = document.querySelector(
      'input[name="option-quantity"][value="' + CSS.escape(targetQty) + '"]'
    );

    if (targetInput && !targetInput.checked) {
      targetInput.checked = true;
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, 0);
};
// ─────────────────────────────────────────────────────────────────────────────

// ================================================================
// APPSTLE WIDGET ENHANCEMENTS
// Paste at the bottom of custom.js
// ================================================================

(function () {
  'use strict';

  var BORDER_COLOR = '#D8D4CC';
  var _initTimer   = null;
  var _pollTimer   = null;

  // ─────────────────────────────────────────────────────────────────
  // HELPERS
  // ─────────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getCurrentVariant() {
    var product = window.__productJSON;
    if (!product) return null;
    var form = document.querySelector('form[action="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    var variantId = idInput ? parseInt(idInput.value) : null;
    if (!variantId) {
      variantId = product.selected_or_first_available_variant_id ||
                  (product.variants && product.variants[0] && product.variants[0].id);
    }
    if (!variantId || !product.variants) return null;
    return product.variants.find(function (v) { return v.id === variantId; }) || null;
  }

  function getUnitPriceLabel(variant) {
    if (!variant || !variant.unit_price_measurement) return null;
    var m = variant.unit_price_measurement;
    return formatMoney(variant.unit_price) + '/' + (m.reference_unit === 'item' ? 'ea.' : m.reference_unit);
  }

  function isSubscribeSelected() {
    var input = document.querySelector('.appstle-selectedSellingPlan');
    return !!(input && input.value && input.value.trim() !== '');
  }

  function isOurNode(node) {
    if (!node) return false;
    if (node.id === 'appstle-price-row') return true;
    return !!(node.closest && node.closest('#appstle-price-row'));
  }

  function appstleReady() {
    // Appstle is ready when both cards are rendered
    return !!(
      document.querySelector('.appstle_one_time_details_wrapper') &&
      document.querySelector('.appstle_subscription_amount_wrapper')
    );
  }

  // ─────────────────────────────────────────────────────────────────
  // 1. WRAPPER BORDER
  // ─────────────────────────────────────────────────────────────────

  function applyWrapperBorder() {
    var wrapper = document.querySelector('.appstle_subscription_wrapper');
    if (!wrapper) return;
    wrapper.style.setProperty('border', '1.5px solid ' + BORDER_COLOR, 'important');
    wrapper.style.setProperty('border-radius', '12px', 'important');
    wrapper.style.setProperty('overflow', 'hidden', 'important');
    wrapper.style.setProperty('gap', '0', 'important');
    wrapper.style.setProperty('padding', '0', 'important');
    var opts = wrapper.querySelectorAll('.appstle_subscription_wrapper_option');
    opts.forEach(function (opt, i) {
      opt.style.setProperty('margin', '0', 'important');
      opt.style.setProperty('border', 'none', 'important');
      opt.style.setProperty('border-radius', '0', 'important');
      if (i > 0) opt.style.setProperty('border-top', '1px solid ' + BORDER_COLOR, 'important');
    });
  }

  // ─────────────────────────────────────────────────────────────────
  // 2. ATC BUTTON — hide OTP price span when S&S active
  // ─────────────────────────────────────────────────────────────────

  function updateAtcButton() {
    var atcPriceEl = document.querySelector('.btn-atc-price');
    if (!atcPriceEl) return;
    var atcDash = atcPriceEl.previousSibling;
    if (isSubscribeSelected()) {
      atcPriceEl.style.setProperty('display', 'none', 'important');
      if (atcDash && atcDash.nodeType === 3) {
        atcDash._orig = atcDash._orig || atcDash.textContent;
        atcDash.textContent = '';
      }
    } else {
      atcPriceEl.style.removeProperty('display');
      if (atcDash && atcDash.nodeType === 3 && atcDash._orig) {
        atcDash.textContent = atcDash._orig;
      }
    }
  }

  // ─────────────────────────────────────────────────────────────────
  // 3. OTP UNIT PRICE
  // ─────────────────────────────────────────────────────────────────

  function setOtpUnitVar(label) {
    // Never blank this variable. A failed variant lookup mid-swap would empty
    // the ::after and collapse the OTP card by 18px, shifting everything below.
    // Keep the last good value; the next successful lookup overwrites it.
    if (!label) return;
    document.documentElement.style.setProperty('--bs-otp-unit', '"' + label + '"');
  }

  function injectOtpUnitPrice() {
    var variant = getCurrentVariant();
    var label = variant ? getUnitPriceLabel(variant) : null;
    // Set on :root — survives Appstle's complete widget rebuild.
    // CSS ::after on the OTP card reads this variable every render.
    setOtpUnitVar(label);
  }

  function injectOtpUnitPriceFromRadios() {
    // Read variant from checked radios directly — form [name="id"] is not
    // yet updated when the change event fires at document level.
    var selected = {};
    document.querySelectorAll('input.product-option:checked').forEach(function (r) {
      selected[r.name.replace(/^option-/, '')] = r.value;
    });
    var product = window.__productJSON;
    if (!product) return;
    var variant = product.variants.find(function (v) {
      return v.options.every(function (optVal, idx) {
        var key = product.options[idx].toLowerCase().replace(/\s+/g, '-');
        return !(key in selected) || selected[key] === optVal;
      });
    });
    var label = null;
    if (variant && variant.unit_price_measurement) {
      var m = variant.unit_price_measurement;
      label = getUnitPriceLabel(variant);
    }
    setOtpUnitVar(label);
  }

  // ─────────────────────────────────────────────────────────────────
  // 4. SUB PRICE ROW — strikethrough left, sale price right, unit below
  // ─────────────────────────────────────────────────────────────────

  function restructureSubPrices() {
    var w = document.querySelector('.appstle_subscription_amount_wrapper');
    if (!w) return;
    var compare = w.querySelector('.appstle_subscription_compare_amount');
    var sale    = w.querySelector('.appstle_subscription_amount:not([class*="sr-only"])');
    if (!compare || !sale) return;

    // Always reapply wrapper column — Appstle resets inline styles on each update
    w.style.setProperty('display', 'flex', 'important');
    w.style.setProperty('flex-direction', 'column', 'important');
    w.style.setProperty('align-items', 'flex-end', 'important');
    w.style.setProperty('gap', '2px', 'important');

    var priceRow = document.getElementById('appstle-price-row');

    if (!priceRow || !priceRow.isConnected) {
      // Create the row once — insert before compare's current position
      priceRow = document.createElement('div');
      priceRow.id = 'appstle-price-row';
      priceRow.style.cssText = 'display:flex;flex-direction:row;align-items:baseline;gap:4px;justify-content:flex-end;width:100%;';
      w.insertBefore(priceRow, compare);
    }

    // Move elements into row in-place — no remove+rebuild, no intermediate broken state
    if (!priceRow.contains(compare)) priceRow.appendChild(compare);
    if (!priceRow.contains(sale))    priceRow.appendChild(sale);
  }

  // ─────────────────────────────────────────────────────────────────
  // 5. UNIT PRICE LABEL — separate observer, never triggers init()
  // ─────────────────────────────────────────────────────────────────
  // MAIN INIT
  // ─────────────────────────────────────────────────────────────────

  function fixUnitLabel() {
    var el = document.querySelector('.appstle_selling_plan_unit_price');
    if (el && el.textContent.includes('/item')) {
      el.textContent = el.textContent.replace('/item', '/ea.');
    }
  }

  function init() {
    if (!appstleReady()) return;
    applyWrapperBorder();
    injectOtpUnitPrice();
    restructureSubPrices();
    fixUnitLabel();
    updateAtcButton();
  }

  // ─────────────────────────────────────────────────────────────────
  // POLL — keep trying until Appstle renders (it loads async)
  // ─────────────────────────────────────────────────────────────────

  function poll() {
    if (appstleReady()) {
      init();
    } else {
      _pollTimer = setTimeout(poll, 100);
    }
  }

  // ─────────────────────────────────────────────────────────────────
  // OBSERVER — reacts to Appstle DOM changes after initial render.
  // Fires fast actions immediately (restructure prices, hide ATC price,
  // fix unit label). Full init() is debounced for the heavier work.
  // ─────────────────────────────────────────────────────────────────

  function pricesReadyInWrapper() {
    var w = document.querySelector('.appstle_subscription_amount_wrapper');
    if (!w) return false;
    return !!(
      w.querySelector('.appstle_subscription_compare_amount') &&
      w.querySelector('.appstle_subscription_amount:not([class*="sr-only"])')
    );
  }

  function scheduleInit() {
    clearTimeout(_initTimer);
    // Immediate actions — fire synchronously to avoid visible flash
    if (pricesReadyInWrapper()) restructureSubPrices();
    fixUnitLabel();
    updateAtcButton();
    injectOtpUnitPrice(); // update OTP unit price text immediately on variant change
    // Full init debounced — handles border, etc.
    _initTimer = setTimeout(init, 250);
  }

  var mainObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type !== 'childList') continue;
      if (isOurNode(m.target)) continue;
      var nodes = Array.from(m.addedNodes).concat(Array.from(m.removedNodes));
      if (nodes.length > 0 && nodes.every(function (n) { return isOurNode(n); })) continue;
      if (m.target.closest && (
        m.target.closest('.appstle_sub_widget') ||
        m.target.closest('.btn-atc')
      )) {
        scheduleInit();
        return;
      }
    }
  });

  mainObserver.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('variant:changed', function () { injectOtpUnitPrice(); setTimeout(init, 100); });

  // Update OTP unit price immediately on radio change — reads from checked
  // radios directly since form [name="id"] hasn't updated yet at this point.
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.classList.contains('product-option')) return;
    injectOtpUnitPriceFromRadios();
  });

  // Start polling immediately — works whether DOM is ready or not
  poll();

})();